import { Card, CardTypeMap, SxProps, Theme} from "@mui/material";
import React from "react";
import { InitialConfig } from "./../../helpers/constants/AppConfig"
import { SectionHeader } from "./SectionHeader";
type ExtProps = {
    title?: string;
    divider?: boolean;
    subcard?: boolean;
    className?: string;
    elevation?: number;
    onClose?:()=>void;
    onDelete?:()=>void;
    onInfo?:()=>void;
    sx?: SxProps<Theme>
    headerBgClass?: string;
    disableDelete?: boolean;
    visibleDelete?: boolean;
}

export const MainCard: React.FC<Partial<CardTypeMap> & ExtProps> = (
    {
        children,
        title,
        divider,
        subcard,
        className,
        elevation,
        onClose,
        onDelete,
        onInfo,
        headerBgClass,
        disableDelete,
        visibleDelete,
        ...rest
    }
) => 
{
    const cn = !!className ? className : 'main-card'; 
    const elev = !!elevation ? elevation : InitialConfig.elevation;

    return (
        <Card className={cn} elevation={elev} {...rest}>

            {/*Card Header*/}
            <SectionHeader title={title} className={headerBgClass} visibleDelete={visibleDelete} disableDelete={disableDelete} divider={divider} subcard={subcard} 
            onClose={onClose} 
            onDelete={onDelete} 
            onInfo={onInfo}
            centerlabel/>
            
            {children}
            
        </Card>
    )

}

